import "./Hospitality.module.css";
import Header from "@/reusable_sections/Header";
import HeroHeader from "./sections/HeroHeader";
import TechnicalExpertise from "./sections/TechnicalExpertise";
import Portfolio from "./sections/Portfolio";
import FooterInfo from "@/reusable_sections/Footer";
export default function HospitalityPage() {
  return <div>
      <Header />
      <HeroHeader />
      <TechnicalExpertise />
      <Portfolio />
      <FooterInfo />
    </div>;
}